import { createFormAction } from "redux-form-saga";
export const FORM_KEY = "SELLER_FORM";
export const SellerFormAction = createFormAction(FORM_KEY);
